// extracted by mini-css-extract-plugin
export default {"colorsList":"ColorPicker_colorsList__7xZs7","colorBox":"ColorPicker_colorBox__PO2xr","active":"ColorPicker_active__kEA4f"};